import React, { useState, useEffect } from 'react';
import { Link } from 'react-router-dom';
import { getLocations } from '../services/api';
import { MapPin } from 'lucide-react';

const LocationsPage = () => {
  const [locations, setLocations] = useState([]);
  const [loading, setLoading] = useState(true);

  useEffect(() => {
    const fetchLocations = async () => {
      try {
        const data = await getLocations();
        setLocations(data);
      } catch (error) {
        console.error('Failed to fetch locations:', error);
      } finally {
        setLoading(false);
      }
    };
    fetchLocations();
  }, []);

  if (loading) {
    return (
      <div className="min-h-screen bg-black flex items-center justify-center">
        <p className="text-white text-xl">Loading locations...</p>
      </div>
    );
  }

  return (
    <div className="min-h-screen bg-black">
      {/* Hero Section with Background Image */}
      <div className="relative h-96 overflow-hidden">
        <img
          src="https://customer-assets.emergentagent.com/job_extreme-homepage/artifacts/miyamfwr_MAP.jpg"
          alt="Bungee Jumping Locations Map"
          className="w-full h-full object-cover"
        />
        <div className="absolute inset-0 bg-black/35"></div>
        <div className="absolute inset-0 flex items-center px-4 sm:px-6 lg:px-8">
          <div className="max-w-7xl mx-auto w-full">
            <h1 className="text-6xl md:text-8xl font-black text-white uppercase tracking-tight">
              LOCATIONS
            </h1>
          </div>
        </div>
      </div>

      {/* Locations Grid Section */}
      <div className="py-20 bg-black">
        <div className="max-w-7xl mx-auto px-4 sm:px-6 lg:px-8">
          {/* Section Header */}
          <div className="text-center mb-16 space-y-4">
            <h2 className="text-2xl font-bold text-yellow-400 tracking-widest uppercase">
              choose your destination
            </h2>
            <h3 className="text-3xl md:text-4xl font-black text-white">
              Leading Bungee Operator in <span className="text-yellow-400">INDIA</span>
            </h3>
            <p className="text-xl text-gray-400 font-medium">
              Now Jumping Across the Globe
            </p>
          </div>

          {/* Locations Grid */}
          <div className="grid grid-cols-1 md:grid-cols-2 lg:grid-cols-4 gap-6">
            {locations.map((location, index) => (
              <Link
                key={location._id}
                to={location.comingSoon ? '/coming-soon' : `/location/${location.name.toLowerCase().replace(' ', '-')}`}
                className="group relative h-96 rounded-2xl overflow-hidden cursor-pointer transform hover:scale-105 transition-all duration-500"
                style={{
                  animation: `fadeInUp 0.6s ease-out ${index * 0.1}s both`
                }}
              >
                {/* Background Image */}
                <img
                  src={location.image}
                  alt={location.name}
                  className="w-full h-full object-cover transform group-hover:scale-110 transition-transform duration-700"
                />

                {/* Gradient Overlay */}
                <div className="absolute inset-0 bg-gradient-to-t from-black via-black/50 to-transparent opacity-80 group-hover:opacity-90 transition-opacity duration-300"></div>

                {/* Content */}
                <div className="absolute inset-0 p-6 flex flex-col justify-end">
                  <div className="transform group-hover:translate-y-0 translate-y-2 transition-transform duration-300">
                    <h4 className="text-4xl font-black text-yellow-400 mb-2">
                      {location.name.toUpperCase()}
                    </h4>
                    {location.comingSoon && (
                      <div className="inline-block bg-yellow-400/20 text-yellow-400 px-4 py-2 rounded-full text-xs font-bold border border-yellow-400">
                        COMING SOON
                      </div>
                    )}
                  </div>
                </div>

                {/* Shine Effect */}
                <div className="absolute inset-0 opacity-0 group-hover:opacity-100 transition-opacity duration-500">
                  <div className="absolute top-0 left-0 w-full h-full bg-gradient-to-r from-transparent via-white/10 to-transparent transform -skew-x-12 group-hover:translate-x-full transition-transform duration-1000"></div>
                </div>
              </Link>
            ))}
          </div>
        </div>
      </div>
    </div>
  );
};

export default LocationsPage;